const unserialize = require("locutus/php/var/unserialize");
class AbstractForm {
  constructor(element) {
    this.element = element;
    this.websiteDomain = element.getAttribute("data-website-domain");
    this.pageLang = element.getAttribute("data-page-lang");
    element.addEventListener("submit", e => {
      e.preventDefault(); // prevent FORM from submiting

      //@TODO add validation

      this.sendAction().then(res => {
        if (res === false) {
          return;
        }
        let resUnserialized = unserialize(res.data);
        let resultText = unserialize(resUnserialized.result);
        let divText = document.createElement("div");
        divText.setAttribute("cms-nw-error-container", "true");
        divText.innerHTML = resultText;
        Array.prototype.forEach.call(document.querySelectorAll("[cms-nw-error-container]"), function (node) {
          node.parentNode.removeChild(node);
        });
        element.parentNode.insertBefore(divText, element);
      }).catch(e => {
        console.error("Error while trying to send email", e);
      });
    });
  }
  clearAllErrors() {
    Array.prototype.forEach.call(this.element.querySelectorAll("[data-field-error]"), function (node) {
      node.parentNode.removeChild(node);
    });
  }
  validateAllData(fields) {
    let test = true;
    if (fields["unsubscribe-email"] !== void 0) {
      //unsubscribe email has the same validation as normal, subscribe email
      fields.email = fields["unsubscribe-email"];
    }
    if (fields.email !== void 0) {
      if (this.validateEmail(fields.email) === false) {
        this.addErrorMessage(__("The field is required"), "Email");
        test = false;
      }
      if (this.validateEmail(fields.email) === true && this.validateEmailString(fields.email) === false) {
        this.addErrorMessage(__("Invalid email address"), "Email");
        test = false;
      }
    }
    if (fields.privacyPolicy !== void 0) {
      if (this.validateRequiredField("privacyPolicy", fields.privacyPolicy) === false) {
        this.addErrorMessage(__("privacyPolicy_not_accepted"), "privacyPolicy");
        test = false;
      }
    }
    if (fields.name !== void 0) {
      if (this.validateRequiredField("Name", fields.name) === false) {
        this.addErrorMessage(__("The field is required"), "Name");
        test = false;
      }
    }
    if (fields.company !== void 0) {
      if (this.validateRequiredField("Company", fields.company) === false) {
        this.addErrorMessage(__("The field is required"), "Company");
        test = false;
      }
    }
    if (fields.birthdate !== void 0) {
      if (this.validateRequiredField("Birthdate", fields.birthdate) === false) {
        this.addErrorMessage(__("The field is required"), "Birthdate");
        test = false;
      }
    }
    if (fields.title !== void 0) {
      if (this.validateRequiredField("Title", fields.title) === false) {
        this.addErrorMessage(__("The field is required"), "Title");
        test = false;
      }
    }
    if (fields.sex !== void 0) {
      if (this.validateRequiredField("Gender[]", fields.sex) === false) {
        this.addErrorMessageAfterElement(__("The field is required"), "Gender", this.element.querySelector("fieldset.Gender"));
        test = false;
      }
    }
    return test;
  }
  validateRequiredField(field, val) {
    // see if required
    let el = this.element.querySelector(`[name="${field}"]`);
    if (el) {
      let required = el.getAttribute("data-field-required");
      if (required !== null) {
        if (val === "" || val === null || val === false) {
          return false;
        }
      }
    }
    return true;
  }
  validateEmailString(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  validateEmail(email) {
    if (email === "" || email === void 0 || email === null) {
      return false;
    } else {
      return true;
    }
  }
  removerErrorMessages(elementName) {
    let errorDiv = this.element.querySelector(`[data-field-error="${elementName}"]`);
    if (errorDiv) {
      errorDiv.remove();
    }
  }
  getErrorMessageElement(msg, elementName) {
    let div = document.createElement("div");
    div.setAttribute("data-field-error", elementName);
    div.innerHTML = msg;
    return div;
  }
  addErrorMessage(msg, elementName) {
    let errorMsg = this.getErrorMessageElement(msg, elementName);
    let target = this.element.querySelector(`[name="${elementName}"]`);
    this.removerErrorMessages(elementName);
    target.parentNode.insertBefore(errorMsg, target.nextSibling);
  }
  addErrorMessageAfterElement(msg, elementName, element) {
    let errorMsg = this.getErrorMessageElement(msg, elementName);
    this.removerErrorMessages(elementName);
    element.parentNode.insertBefore(errorMsg, element.nextSibling);
  }
  async postData(url = "", data = "") {
    // Default options are marked with *
    const response = await fetch(url, {
      method: "POST",
      // *GET, POST, PUT, DELETE, etc.
      mode: "cors",
      // no-cors, *cors, same-origin
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      redirect: "follow",
      // manual, *follow, error
      referrerPolicy: "no-referrer",
      // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: `data=${data.data}` // body data type must match "Content-Type" header
    });
    return response.text(); // parses JSON response into native JavaScript objects
  }
}
export default AbstractForm;